import type { BillingScheduleBreakdown } from "./api";
import type { PlanFieldItem } from "./year-card";

/**
 * Builds the commercial billing schedule breakdown array used by save + send-for-approval APIs.
 * Only includes plan years that have a generated billing schedule (non-empty rows).
 */
export function buildCommercialBillingScheduleBreakdownPayload(plans: PlanFieldItem[]): BillingScheduleBreakdown[] {
  return plans.reduce<BillingScheduleBreakdown[]>((acc, plan) => {
    if (plan?.billingScheduleRows?.length > 0) {
      const serviceChargePlan = plan?.serviceCharge
        ? {
            serviceChargePlan: {
              annualRent: String(plan?.serviceCharge?.annualRent),
              ...(plan?.serviceCharge?.chargeValue != null ? { chargeValue: plan?.serviceCharge?.chargeValue } : {}),
              installments: plan?.serviceCharge?.installments?.value,
              rentType: plan?.serviceCharge?.rentType?.value,
            },
          }
        : {};

      acc.push({
        noOfYear: plan?.noOfYear,
        commercialBillingSchedule: plan?.billingScheduleRows,
        commercialServiceCharge: plan?.serviceChargeSchedule?.length > 0 ? plan?.serviceChargeSchedule : [],
        ...serviceChargePlan,
      });
    }
    return acc;
  }, []);
}
